module.exports = __webpack_public_path__ + "static/TT1332_TW-MARK-M04-clean-6d9c86335f8c28e8c7d2804c6c0b288b.png";